export default __webpack_public_path__ + "static/media/35A32A_1_0-976f6d4536155d460e260eb7dd2ec434.2450af27.woff";